import React, { useEffect, useState } from 'react';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage, useIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import { useSelector } from 'react-redux';

import Link from '../../Link/Link';
import Loader from '../../Common/Loader/Loader';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';

import messages from '../../../locale/messages';
import submit from './submit';
import validate from './validate';

import bt from '../../../components/commonStyle.css';
import s from './ManageProviderOnBoardingScreens.css';

const RenderQuill = ({ input, meta: { touched, error } }) => {
    const intl = useIntl();
    const [Editor, setEditor] = useState(null);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            import('../../Common/Editor/CustomEditor').then(mod => setEditor(() => mod.Editor));
        }
    }, []);
    return (
        Editor &&
        <div>
            <Editor
                {...input}
            />
            {touched && error && <span className={bt.errorMessage}>{intl.formatMessage(error)}</span>}
        </div>
    )
}

const AddOnBoardingScreens = (props) => {

    const { onSubmit, handleSubmit, submitting } = props;

    const { formatMessage } = useIntl();
    const loading = useSelector(state => state?.loader?.ProviderOnBoardingScreen);
    return (
        <Form className={s.fullWidth} onSubmit={handleSubmit(onSubmit)}>
            <div className='oneColumnGrid'>
                <Field
                    name="pageTitle"
                    type="text"
                    component={InputFieldComponent}
                    label={formatMessage(messages.pageTitle)}
                    placeholder={formatMessage(messages.pageTitle)}
                    inputClass={bt.formControlInput}
                />
                <div className='quillBox'>
                    <label className={bt.commonLabelText}><FormattedMessage {...messages.content} /></label>
                    <Field name="content" component={RenderQuill} />
                </div>
            </div>
            <div className={cx('doubleBtnFlexEnd', bt.spaceTop4)}>
                <Link to={'/siteadmin/provider-onboarding-screens'} className={bt.btnSecondary} ><FormattedMessage {...messages.goBack} /></Link>
                <Loader
                    type={"button"}
                    label={formatMessage(messages.submitButton)}
                    show={loading}
                    buttonType={'submit'}
                    className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                    disabled={submitting || loading}
                />
            </div>
        </Form>
    );
}

export default reduxForm({
    form: 'AddOnBoardingScreens',
    onSubmit: submit,
    validate: validate
})(withStyles(bt, s)(AddOnBoardingScreens));